<template>
  <div class="attention_field">
    <div class="attention_content_title">关注的领域</div>
    <div class="attention_tip" v-if="group_subscribe.length == 0">
      <p>选择您关注的领域，让动脉橙更懂你~</p>
    </div>
    <div class="field_checked" v-if="group_subscribe.length > 0">
      <div class="checked">
        <div class="checked1">
          已关注
        </div>
        <div class="checked3">
          <a v-if="!all_show && group_subscribe.length > 10" @click="showMore">更多<i class="iconfont">&#xe648;</i></a>
          <a v-if="all_show && group_subscribe.length > 10" @click="showMore">收起<i class="iconfont">&#xe63b;</i></a>
        </div>
      </div>
      <div class="checked2">
        <div class="tag_loading" v-if="tag_loading">
          <Spin fix>
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          </Spin>
        </div>
        <Dropdown class="cancel" placement="bottom-start" @on-click="deleteConfirm(item.id)" v-for="(item,index) in show_group_subscribe" :key="item.id">
          <span class="span_tag"><i class="iconfont">&#xe64b;</i>{{item.sub_type_id | dealName(allItrackTags)}}</span>
          <DropdownMenu slot="list">
            <DropdownItem>取消关注</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    </div>
    <div class="field_options">
      <ul class="field_list">
        <li v-for="item,index in tags" :key="index" v-if="item.children.length > 0">
          <p class="field_title"><img :src="static_img_url + 'pic/tag-ico-'+item.id+'.png'">{{item.name}}</p>
          <TabOptionAll v-for="item2,index2 in item.children" :key="index2" :data="item2" :groupSub="group_subscribe" @selectField="selectField"></TabOptionAll>
        </li>
      </ul>
    </div>
    <Spin fix class="a-fix" v-if="loading1">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>

  </div>
</template>

<script>
import TabOptionAll from '@/components/TabOptionAll.vue'
import { attention_mixins } from 'js/attention_mixins'
import { addSubscribe, deleteSubscribe } from '../../../service'

export default {
  name: 'AttentionField',
  mixins: [attention_mixins],
  components: {
    TabOptionAll,
  },
  computed: {
    static_img_url() {
      return this.$store.state.static_img_url
    },
    group_subscribe() {
      let g_subscribe = this.attention.subscribe.filter((b) => b.sub_type == '20')
      if (this.all_show) {
        this.show_group_subscribe = g_subscribe
      } else {
        this.show_group_subscribe = g_subscribe.slice(0, 10)
      }
      return g_subscribe
    },
    tags() {
      let arr1 = []
      let arr2 = this.allItrackTags.filter((item) => item.level == 2)
      let arr3 = this.allItrackTags.filter((item) => item.level == 3)

      this.allItrackTags.map((item) => {
        if (item.level == 1) {
          arr1.push(Object.assign(item, { children: [] }))
        }
      })

      arr2.map((item) => {
        let index = arr1.findIndex((a) => item.pid == a.id)
        if (index > -1) {
          arr1[index].children.push(Object.assign(item, { children: [] }))
        }
      })

      arr3.map((item) => {
        let index1 = arr1.findIndex((a) => item.gpid == a.id)
        if (index1 > -1) {
          let index2 = arr1[index1].children.findIndex((a) => item.pid == a.id)
          if (index2 > -1) {
            arr1[index1].children[index2].children.push(item)
          }
        }
      })

      return arr1
    },
  },
  data() {
    return {
      all_show: false,
      tag_loading: false,
      clear_loading: false,
      show_group_subscribe: [],
      loading1: true,
    }
  },
  methods: {
    selectField(val, is_active) {
      if (is_active) {
        let index = this.group_subscribe.findIndex((item) => item.sub_type_id == val)
        if (index > -1) {
          this.deleteConfirm(this.group_subscribe[index].id)
        } else {
          this.$Message.error('未找到对象！')
        }
      } else {
        this.fieldChecked(val)
      }
    },
    async fieldChecked(val) {
      if (!this.tag_loading) {
        this.tag_loading = true
        const add_tag = {
          sub_type: '20',
          sub_type_id: val,
          user_key: this.user_key,
        }
        let res = await addSubscribe(add_tag, (error) => {
          this.$Message.error('请求错误！')
        })
        if (res.status == 'success') {
          this.getSubscribeList(() => {
            this.$Message.success('关注成功！')
            this.tag_loading = false
          })
        } else {
          console.log(res)
        }
      } else {
        this.$Message.loading('添加中，请勿重复操作！')
      }
    },
    deleteConfirm(val) {
      const _that = this
      layer.confirm(
        '确定不再关注？',
        {
          title: false,
          offset: '100px',
          skin: 'layer-custom',
          btn: ['确定', '取消'], //按钮
        },
        function () {
          _that.clearAttention(val)
          layer.closeAll()
        },
        function () {
          layer.closeAll()
        }
      )
    },
    async clearAttention(val) {
      if (!this.clear_loading) {
        this.clear_loading = true
        const del_group = {
          op_type: 'cancel',
          subscribe_id: val,
          user_key: this.user_key,
        }
        let res = await deleteSubscribe(del_group, (error) => {
          this.$Message.error('请求错误！')
        })
        if (res.status == 'success') {
          this.getSubscribeList(() => {
            this.clear_loading = false
            this.$Message.success('取消成功！')
          })
        } else {
          this.$Message.error(res.message)
        }
      } else {
        this.$Message.loading('删除中，请勿重复操作！')
      }
    },
    showMore() {
      this.all_show = !this.all_show
      if (this.all_show) {
        this.show_group_subscribe = this.group_subscribe
      } else {
        this.show_group_subscribe = this.group_subscribe.slice(0, 10)
      }
    },
    getcb() {
      this.loading1 = false
    },
  },
  created() {
    this.getMeta(this.getcb)
    this.getAppMeta()
  },
}
</script>

<style lang="stylus" scoped>
@import '~styles/attention.stylus'
.field_title
  line-height 1
</style>
